import { Nullable } from '../Nullable';
import { UnitOptionLimit } from './UnitOptionLimit';
import { UnitOptionUsePoint } from './UnitOptionUsePoint';
import { UnitOptionAvailability } from './UnitOptionAvailability';
import { UnitOptionChangeProfil } from './UnitOptionChangeProfil';
import { UnitOptionOrganisationMode } from './UnitOptionOrganisationMode';
import { UnitOptionChangeModelRule } from './UnitOptionChangeModelRule';
import { ModelRuleUnitTroop } from './ModelRuleUnitTroop';
import { UnitOptionMagicItemCategory } from './UnitOptionMagicItemCategory';
import { IEntityId } from '../IEntityId';
import { IConstrainedObject } from '././constraints/iconstrained-object';
import { EntityId } from '../EntityId';
import { IPositionnable } from '../IPositionnable';
import { IPriceable } from '../IPriceable';

export interface UnitOption
  extends IEntityId<number>,
    IConstrainedObject,
    IPositionnable,
    IPriceable {
  unit_id: number;
  parent_id: Nullable<number>;
  category: UnitOptionCategory;
  is_per_model: boolean;
  hasChoises: Nullable<number>;
  weight: number;
  mount_id: Nullable<number>;
  mount_and_carac_points: boolean;
  organisation_mode: UnitOptionOrganisationMode;
  is_multiple: boolean;
  is_required: boolean;
  magic_path_id: Nullable<number>;
  organisation_id: Nullable<number>;
  army_organisation_id: Nullable<number>;
  max: Nullable<number>;
  modelRuleIds: string[];
  magic_item_categories: Array<UnitOptionMagicItemCategory>;
  limits: Array<UnitOptionLimit>;
  availabilities: Array<UnitOptionAvailability>;
  availabilityModifiers: Array<UnitOptionAvailability>;
  hideNotActivated: boolean;
  isDefaultInList: boolean;
  useAllActivators: boolean;
  useAllDesactivators: boolean;
  use_points: UnitOptionUsePoint;
  canBeSelected: boolean;
  unitBase: EntityId<string> | null;
  unitHeight: EntityId<string> | null;
  changeProfil: boolean;
  changeModelRules: Array<UnitOptionChangeModelRule & ModelRuleUnitTroop>;
  changeProfils: Array<UnitOptionChangeProfil>;
  magicStrandardId: string | null;
  magicItemId: string | null;
}

export enum UnitOptionCategory {
  Generic = 0,
  General = 1,
  BSB = 2,
  ExtraSpells = 4,
  Mount = 5,
  Equipment = 6,
  MagicEquipment = 7,
  MagicLvl = 8,
  MagicPath = 9,
  M = 10,
  S = 11,
  C = 12,
  MagicBanner = 13,
  SpecialRule = 14,
  OneChoice = 15,
  MustChoice = 16,
  WizardApprentice = 17,
  WizardAdept = 18,
  WizardMaster = 19,
  MayTake = 21,
  Spell = 22,
  MagicItemCategory = 23,
  MagicItem = 24,
  MagicStandard = 25,
  UnitEquipment = 26,
}
